module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/esmeralda_goober_wave-2bdb9e5ebafcf6d5d72017482c38d41f.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/esmeralda_goober_wave.png
// module id = 2488
// module chunks = 2